export default __webpack_public_path__ + "3d31db207b15369038192ddc2a39923c.png";